export const catUrl = (cat, parentSlug = null) => {
  if (!cat) return "/ara";
  if (cat.slug === "dadya-parfum") return "/dadya-parfum";
  if (parentSlug === "dadya-parfum") return `/dadya-parfum/${cat.slug}`;
  return `/kategori/${cat.slug}`;
};
